export enum EntityType {
  PRIMITIVE = 'PRIMITIVE',
  PROPERTY = 'PROPERTY',
  METHOD_CALL_START = 'METHOD_CALL_START',
  FUNCTION_CALL_START = 'FUNCTION_CALL_START',
  CALL_END = 'CALL_END',
  UNSUPPORTED = 'UNSUPPORTED',
}
